import { inject, injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type { IMainServerSub, IUnreadTicketsCountUpdated, ServerEventBase } from '@/services/transport/serverEvents'
import type TicketCountService from '@/services/domain/tickets/ticketCountService'
import type { TicketCountPreloaderService } from '@/services/preloaders/ticketCountPreloaderService'

@injectable()
export class TicketCountSubscriptionResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.ServerSubscriptionService)
    protected readonly serverSubscriptionService: IMainServerSub,
    @inject(SERVICE_TYPES.TicketCountService) protected readonly ticketCountService: TicketCountService,
    @inject(SERVICE_TYPES.TicketCountPreloaderService)
    protected readonly ticketCountPreloaderService: TicketCountPreloaderService,
  ) {}

  private readonly unreadTicketsCountUpdatedEvent = 'unreadTicketsCountUpdated'

  private unreadTicketsCountUpdatedHandler = (
    e: ServerEventBase<'unreadTicketsCountUpdated', IUnreadTicketsCountUpdated>,
  ) => {
    this.ticketCountService.updateUnreadTicketsCount(e.payload.count)
    this.ticketCountPreloaderService.markUnreadTicketsCountAsPreloaded()
  }

  public async resolve() {
    this.serverSubscriptionService.subscribe(this.unreadTicketsCountUpdatedEvent, this.unreadTicketsCountUpdatedHandler)
  }

  public async unresolve() {
    this.serverSubscriptionService.unsubscribe(
      this.unreadTicketsCountUpdatedEvent,
      this.unreadTicketsCountUpdatedHandler,
    )
    this.ticketCountPreloaderService.markUnreadTicketsCountAsNotPreloaded()
  }
}
